import { render } from "./Matricula.vue?vue&type=template&id=512aed40"
import script from "./Matricula.vue?vue&type=script&lang=js"
export * from "./Matricula.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__